export default __webpack_public_path__ + "static/media/shaurya-circle-icon.b695a5ca.png";